import { formatDate } from '@angular/common';
import { Component, OnInit, Inject, ViewChild, ElementRef, OnChanges, SimpleChanges, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-print-order-byfurgation-new',
  standalone: false,
  templateUrl: './print-order-byfurgation-new.component.html',
  styleUrl: './print-order-byfurgation-new.component.scss'
})
export class PrintOrderByfurgationNewComponent implements OnInit, OnChanges {

  @Input() printOrderData: any
  ///////////////////////new componunt start ////////////////////////////////
  newValue: any
  newValue1: any
  abhikartaData = [
    {
      "mode": "विक्री",
      "name": "हस्ते",
      "prati": 0
    },
    {
      "mode": "जादा विक्री",
      "name": "थेट",
      "prati": 0
    }

  ]
  jadaAnkData = [
    {
      "mode": "पार्सल जादा वर्गणी",
      "prati": 0,
      "checkboxShow": false
    },
    {
      "mode": "अनामत जादा ",
      "prati": 0,
      "checkboxShow": false
    },
    {
      "mode": "पेंडींग जादा वर्गणी ",
      "prati": 0,
      "checkboxShow": false
    }
  ]
  karyalayData = []
  // jadaAnkData: any = [{ "mode": "", "prati": 0 }]
  varganidarTotal: number = 0
  jadaAnkTotal: number = 0
  supremBhetTotal: number = 0
  abhikartaTotal: number = 0
  lengthOfList: Number = 0
  middleIndex: any = 0

  lengthOfSapremBhet: Number = 0
  middleIndexSapremBhet: any = 0
  isFirstVisible: boolean = true;
  districtwiseData: any
  districtwiseSapremBhetData: any
  sundayankDate: any
  dispatchankDate: any
  total_sub_count = 0;
  totalparcel = 0;
  totalanksankhya = 0;
  filtereddistrictwisesubcout = [];
  disRepData = [];
  // type: any;
  state: any
  district: any
  distributionMode: any
  subDistributionMode: any
  country: any
  updateStatus: any
  issuedate: any
  deleveryModeList: any = []
  subscribeTypes: any = []
  dataTemp: any
  districtWiseData: any = []
  sapremBhet: any = [{ "mode": "", "prati": 0 }]
  lengthOfkaryalay: number = 0;
  indexOfKaryalay: number = 0
  ///////////////////////////////////////////////new componunt end//////////////////////////////////



  printorderData;
  today = new Date();
  startDate = '';
  endDate = '';
  startDateSave = '';
  endDateSave = '';
  tempdata = [
    { no: 1, name: 'अभिकर्ता', prati: 0, shera: '' },
    { no: 2, name: 'वर्गणी', prati: 0, shera: '' },
    // { no: 3, name: 'प्रति अभिकर्ता सप्रेम भेट', prati: 0, shera: '' },
    { no: 3, name: 'सप्रेम भेट', prati: 0, shera: '' },
    { no: 4, name: 'अभिकर्ता सप्रेम भेट', prati: 0, shera: '' },
    { no: 5, name: 'प्रतिनिधी सप्रेम भेट', prati: 0, shera: '' },
    { no: 6, name: 'संपादकीय सप्रेम भेट', prati: 0, shera: '' },
    { no: 7, name: 'जाहिरात सप्रेम भेट', prati: 0, shera: '' },
    { no: 8, name: 'कार्यालय सप्रेम भेट', prati: 0, shera: '' },
    { no: 9, name: 'कृषी विवेक', prati: 0, shera: '' },
    { no: 10, name: 'जादा अंक', prati: 0, shera: '' },
  ];

  testdata = [
    { name: '५० जी एस एम मफलीथो पेपर ' },
    { name: '६५ जी एस एम एलडब्लुसी पेपर ' },
    { name: '९० जी एस एम आर्ट  पेपर' },
  ];

  totalprati = 0;
  totalpsankhya: any = 0;

  // tempData = [
  //   {
  //     prushta_kr: '01-02 व 51-52',
  //     prushta_sankhya: '4',
  //     prakar: 'रंगीत',
  //     pane_denar: 'गुरुवार',
  //   },
  //   {
  //     prushta_kr: '03-12 व 41-50',
  //     prushta_sankhya: '20',
  //     prakar: 'कृष्णधवळ',
  //     pane_denar: 'शुक्रवार',
  //   },
  //   {
  //     prushta_kr: '13-20 व 33-40',
  //     prushta_sankhya: '16',
  //     prakar: 'रंगीत',
  //     pane_denar: 'गुरुवार',
  //   },
  //   {
  //     prushta_kr: '21-26 व 27-32',
  //     prushta_sankhya: '12',
  //     prakar: 'कृष्णधवळ',
  //     pane_denar: 'बुधवार',
  //   },
  //   {
  //     prushta_kr: '',
  //     prushta_sankhya: '',
  //     prakar: '',
  //     pane_denar: '',
  //   },
  // ];


  tempData = [
    {
      prushta_kr: '01-02 व 43-44',
      prushta_sankhya: '4',
      prakar: 'रंगीत',
      pane_denar: 'बुधवार',
    },
    {
      prushta_kr: '03-10 व 35-42',
      prushta_sankhya: '16',
      prakar: 'कृष्णधवल',
      pane_denar: 'गुरुवार',
    },
    {
      prushta_kr: '11-14 व 31-34',
      prushta_sankhya: '8',
      prakar: 'रंगीत',
      pane_denar: 'बुधवार',
    },
    {
      prushta_kr: '15-18 व 27-30',
      prushta_sankhya: '8',
      prakar: 'कृष्णधवल',
      pane_denar: 'बुधवार',
    },
    {
      prushta_kr: '19-22 व 23-26',
      prushta_sankhya: '8',
      prakar: 'रंगीत',
      pane_denar: 'मंगळवार',
    },
    {
      prushta_kr: '',
      prushta_sankhya: '',
      prakar: '',
      pane_denar: '',
    },
  ];


  issue_type: any;

  constructor(
    private dialogref: MatDialogRef<PrintOrderByfurgationNewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) { }
  total: any
  jadaVarganiNew: any = 0
  extraParamList: any = []
  monthArray = [
    {
      marathiMonthName: "जानेवारी",
      englishMonthName: "January",
      englishMonthNo: "01"
    },
    {
      marathiMonthName: "फेब्रुवारी",
      englishMonthName: "फेब्रुवारी",
      englishMonthNo: "02"
    },
    {
      marathiMonthName: "मार्च",
      englishMonthName: "March",
      englishMonthNo: "03"
    },
    {
      marathiMonthName: "एप्रिल",
      englishMonthName: "April",
      englishMonthNo: "04"
    },
    {
      marathiMonthName: "मे",
      englishMonthName: "May",
      englishMonthNo: "05"
    },
    {
      marathiMonthName: "जून",
      englishMonthName: "June",
      englishMonthNo: "06"
    },
    {
      marathiMonthName: "जुलै",
      englishMonthName: "July",
      englishMonthNo: "07"
    },
    {
      marathiMonthName: "ऑगस्ट",
      englishMonthName: "August",
      englishMonthNo: "08"
    },
    {
      marathiMonthName: "सप्टेंबर",
      englishMonthName: "September",
      englishMonthNo: "09"
    },
    {
      marathiMonthName: "ऑक्टोबर",
      englishMonthName: "October",
      englishMonthNo: "10"
    },
    {
      marathiMonthName: "नोव्हेंबर",
      englishMonthName: "November",
      englishMonthNo: "11"
    },
    {
      marathiMonthName: "डिसेंबर",
      englishMonthName: "December",
      englishMonthNo: "12"
    }
  ]
  getMarathiMonthName(monthNo: string): string {
    const month = this.monthArray.find(m => m.englishMonthNo === monthNo);
    return month ? month.marathiMonthName : '';
  }
  ngOnChanges(changes: SimpleChanges): void {

    this.startDate = this.printOrderData.startDate;
    this.endDate = this.printOrderData.endDate;
    this.startDateSave = this.printOrderData.startDate;
    this.endDateSave = this.printOrderData.endDate;
    this.varganidarTotal = this.printOrderData.varganidarTotal,
      this.abhikartaTotal = this.printOrderData.abhikartaTotal,
      this.supremBhetTotal = this.printOrderData.supremBhetTotal,
      this.total = this.printOrderData.total,
      this.jadaAnkTotal = this.printOrderData.jadaAnkTotal;
    this.krushiValue = this.printOrderData.krushiValue;
    this.karyalayData = this.printOrderData.karyalayData;
    this.jadaVarganiNew = this.printOrderData.jadaVarganiNew;
    this.extraParamList = this.printOrderData.extraParamList;
    this.getweekcount()
    this.getPrintOrderData();
    // this.totalPrati();
    this.tempdata.map((a) => {
      if (a.name === 'वर्गणी') {
        a.prati = this.varganidarTotal;
      }
      if (a.name === 'सप्रेम भेट') {
        a.prati = this.supremBhetTotal;
      }
      if (a.name === 'कृषी विवेक') {
        a.prati = this.krushiValue;
      }
      if (a.name === 'अभिकर्ता') {
        a.prati = this.abhikartaTotal;
      }
      if (a.name === 'जादा अंक') {
        a.prati = this.jadaVarganiNew;
      }
    });
    debugger
    this.tempData.forEach((element: any) => {
      this.totalpsankhya = this.totalpsankhya + Number(element.prushta_sankhya);
    });
    this.tempdata.forEach((element: any) => {
      element.prati = this.getValueFromListByName(element.name) != undefined ? this.getValueFromListByName(element.name) : element.prati;
    });
    this.extraParamList.forEach((element: any) => {
      let obj: any = {};
      obj.prati = element.prati;
      obj.name = element.mode;
      obj.no = Number(this.tempdata[this.tempdata.length - 1].no) + 1;
      obj.shera = "";
      this.tempdata.push(obj);
    });
    console.log(this.tempdata)

    let date1 = this.startDate.split("-");
    let monthMarathi = this.getMarathiMonthName(date1[1]);

    this.startDate = date1[2] + ' ' + monthMarathi + ' ' + date1[0];

    let enddate1 = this.endDate.split("-");
    let monthMarathiEndDate = this.getMarathiMonthName(enddate1[1]);
    this.endDate = enddate1[2] + ' ' + monthMarathiEndDate + ' ' + enddate1[0];
  }
  getValueFromListByName(name: any): Number {
    let obj = this.karyalayData.filter((x: any) => x.mode == (name));
    let value = obj.length > 0 ? obj[0].prati : null;
    if (value == null) {
      return undefined;
    } else {
      return Number(value);
    }

  }
  year: any;
  sdate: any;
  edate: any;

  getweekcount() {
    const issuedate = new Date(this.data['issuedate']);
    this.issue_type = this.data.issuetype
    const month = issuedate.getMonth() + 1; // Adding 1 to get month starting from 1 (January is 1)
    const year = this.getYearFromDate(issuedate);

    if (month >= 1 && month <= 3) { // If month is January to March
      this.sdate = new Date(year - 1, 3, 1); // April 1st of the previous year
      this.edate = new Date(year, 2, 31); // March 31st of the current year
    } else { // If month is April to December
      this.sdate = new Date(year, 3, 1); // April 1st of the current year
      this.edate = new Date(year + 1, 2, 31); // March 31st of the next year
    }
    this.weeksCount = this.calculateWeeks(this.sdate, this.edate);
  }

  weeksCount: any;

  calculateWeeks(startDate: Date, endDate: Date): number {
    let weekCount = 0;
    let currentDate = new Date(startDate);

    // Find the first Sunday on or after the start date
    while (currentDate.getDay() !== 0) {
      currentDate.setDate(currentDate.getDate() + 1);
    }

    // Count weeks from the first Sunday until the end date
    while (currentDate <= endDate) {
      if (new Date(this.data['issuedate']) >= currentDate) {
        weekCount++;
      }
      currentDate.setDate(currentDate.getDate() + 7); // Move to the next Sunday
    }

    return weekCount;
  }

  getYearFromDate(date: Date): number {
    return date.getFullYear();
  }

  ngOnInit(): void {
    /////////////////for New Componunt Start///////////////////////////////////////
    this.districtwiseSapremBhetData = this.data['data'];
    this.sundayankDate = this.data['sundaydate'];
    this.dispatchankDate = this.data['dispatchdate'];
    // this.type = this.data['type']
    // this.updateStatus = this.data['updateStatus']
    this.issuedate = this.data['issuedate']
    this.state = this.data.state;
    this.district = this.data.district;
    this.country = this.data.country;
    this.distributionMode = this.data.distributionMode;
    this.deleveryModeList = this.data.deleveryModeList
    this.subscribeTypes = this.data.subscribeTypes
    this.districtwiseData = this.data.districtWiseData;
    // this.toggleMethod();

    this.printOrderData = {
      districtwiseSapremBhetData: this.districtwiseSapremBhetData,
      sundayankDate: this.sundayankDate,
      dispatchankDate: this.dispatchankDate,
      updateStatus: this.updateStatus,
      issuedate: this.issuedate,
      state: this.state,
      country: this.country,
      distributionMode: this.distributionMode,
      deleveryModeList: this.deleveryModeList,
      subscribeTypes: this.subscribeTypes,
      districtwiseData: this.districtwiseData



    }

    /////////////////for New Componunt End///////////////////////////////////////


    // // this.printorderData = this.data['data'];
    // this.endDate = this.data['issuedate'];
    // let weekfirstday =
    //   new Date(this.data['issuedate']).getDate() -
    //   new Date(this.data['issuedate']).getDay();
    // this.startDate = formatDate(
    //   new Date(this.data['issuedate']).setDate(weekfirstday - 6),
    //   'yyyy-MM-dd',
    //   'en-IN',
    //   'GMT+0530'
    // );

    // this.getweekcount()
    // // console.log(this.endDate);
    // // console.log(this.startDate);

    // // console.log(this.data);

    // this.getPrintOrderData();
    // // this.getPrintOrderDataByFurgation();
    // this.totalPrati();






  }

  getPrintOrderData() {
    this.service
      .getPrintOrderData(this.startDate, this.endDate, this.issue_type)
      .subscribe((res) => {
        // console.log(res);
        // this.tempdata.map((a) => {
        //   if (a.name === 'वर्गणी') {
        //     a.prati = parseInt(res['vargani']);
        //   } else if (a.name === 'स. भेट') {
        //     a.prati = parseInt(res['s_bhet']);
        //   }
        // });
        this.totalPrati();
      });
  }
  listOfNotIn: any
  finalList: any
  getPrintOrderDataByFurgation() {
    this.service.getPrintOrderDataByFurgation(this.startDate, this.endDate, this.issue_type).subscribe((res: any) => {
      console.log(res);
      this.listOfNotIn = res.list1;
      this.listOfNotIn = res.list2;
      let mergedList = this.listOfNotIn.map((item, index) => {
        return {
          subcription_not_in_values_total: item.subcription_not_in_values_total,
          subscription_type_not_in: item.subscription_type_not_in,
          subcription_values_total: this.listOfNotIn[index].subcription_values_total,
          subscription_type_in: this.listOfNotIn[index].subscription_type_in
        }
        this.finalList = mergedList;
      });
      console.log(this.finalList)
    });
  }
  exportexcel(fileName): void {
    /* table id is passed over here */
    let element = document.getElementById('print-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }

  addTempData(event, index, key) {
    this.totalpsankhya=0;
    this.tempData[index][key] = event.target.value;
    this.tempData.forEach((element: any) => {
      this.totalpsankhya = this.totalpsankhya + Number(element.prushta_sankhya!=""?element.prushta_sankhya:0);
    });
    // switch (key) {
    //   case 'prushta_kr':
    //     break;

    //   case 'prushta_sankhya':
    //     this.tempData[index]['prushta_sankhya'] = event.target.value;
    //     break;

    //   case 'prakar':
    //     this.tempData[index]['prakar'] = event.target.value;
    //     break;

    //   case 'pane_denar':
    //     this.tempData[index]['pane_denar'] = event.target.value;
    //     break;
    // }
    console.log(this.tempData);
    // this.calculateTotal();
  }

  calculateTotal() {
    this.totalpsankhya = 0;
    for (let index = 0; index < Object.keys(this.tempData).length; index++) {
      this.totalpsankhya +=
        this.tempData[index]['prushta_sankhya'] == ''
          ? 0
          : parseInt(this.tempData[index]['prushta_sankhya']);
    }
    this.tempdata.forEach((element: any) => {
      this.totalpsankhya = this.totalpsankhya + Number(element.prushta_kr);
    });
  }

  addtempdata(event, index, name) {
    this.tempdata[index][name] =
      name === 'name' ? event.target.value : parseInt(event.target.value);
    this.totalPrati();
  }

  totalPrati() {
    this.totalprati = 0;
    for (let index = 0; index < Object.keys(this.tempdata).length; index++) {
      this.totalprati += this.tempdata[index]['prati'];
    }
  }

  closeDialog() {
    if (
      window.confirm(
        'Are you sure want to close, Please save data before close'
      )
    ) {
      this.dialogref.close();
    }
  }

  save() {
    let data = {
      order_date: formatDate(this.today, 'yyyy-MM-dd', 'en-IN', 'GMT+0530'),
      issue_date_from: this.startDateSave,
      issue_date_to: formatDate(
        this.endDateSave,
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      ),
      // total_prati: this.totalprati,
      total_prati: this.total,
      total_prustha: this.totalpsankhya,
      weeksCount: this.weeksCount,
    };

    // console.log(data);

    let prusthaData = [];
    this.tempData.map((a) => {
      if (
        a['prushta_kr'] != '' ||
        a['prushta_sankhya'] != '' ||
        a['prakar'] != '' ||
        a['pane_denar'] != ''
      ) {
        prusthaData.push(a);
      }
    });
    // console.log(prusthaData);
    // console.log(this.tempdata);

    this.service.insertPrintOrderData(data).subscribe((res) => {
      // console.log(res);

      if (res['success']) {
        this.service
          .insertPrintOrderPrustha(res['id'], prusthaData)
          .subscribe((res1) => {
            // console.log(res1);
          });

        this.service
          .insertPrintOrderTypes(res['id'], this.tempdata)
          .subscribe((res3) => {
            alert('Print order saved successfully');
            this.dialogref.close();
          });
      } else {
        alert(res['msg']);
      }
    });
  }

  addNewtempdata() {
    console.log(this.tempData);
    this.tempdata.push({
      no: this.tempdata.length + 1,
      name: '',
      prati: 0,
      shera: '',
    });
  }






  //////////////////////////////new componungt start ///////////////////////////////////////////////
  @ViewChild('valueInput') valueInputRef!: ElementRef;
  setValue() {
    this.jadaAnkData[this.jadaAnkData.length - 1] = {
      mode: this.newValue,
      prati: Number(this.newValue1),
      checkboxShow: true
    };

    // Push a new empty row for next entry
    this.jadaAnkData.push({
      mode: " ",
      prati: 0,
      checkboxShow: false
    });

    this.lengthOfList = this.jadaAnkData.length;
    this.middleIndex = Math.floor(this.jadaAnkData.length / 2);
    this.jadaAnkTotal = Number(this.jadaAnkTotal) + Number(this.newValue1);
    this.newValue = "";
    this.newValue1 = "";


    setTimeout(() => {
      this.valueInputRef.nativeElement.focus();
    });
  }
  calculation(type: any, districtwiseData: any) {
    this.total_sub_count = 0;
    let tempdata = this.uniqueid(districtwiseData, (a) => a['district']);

    this.filtereddistrictwisesubcout = [];
    for (let index = 0; index < Object.keys(tempdata).length; index++) {
      let arr = districtwiseData.filter(
        (a) => a['district'] == tempdata[index]['district']
      );
      let delivery_mode_unique = this.uniqueid(arr, (a) => a['delivery_mode']);

      let totalTapalCount = 0;
      for (let j = 0; j < Object.keys(delivery_mode_unique).length; j++) {
        let arr1 = arr.filter(
          (a) => a['delivery_mode'] == delivery_mode_unique[j]['delivery_mode']
        );
        if (arr1[0]['delivery_mode'] === type) {
          totalTapalCount = Object.keys(arr1).length;
        }
      }
      this.total_sub_count += totalTapalCount;
    }
    return this.total_sub_count;
  }
  calculation1(type: any, districtwiseData: any) {
    let total_sub_count = 0;
    let tempdata = this.uniqueid(districtwiseData, (a) => a['district']);
    for (let index = 0; index < Object.keys(tempdata).length; index++) {
      let arr = districtwiseData.filter(
        (a) => a['district'] == tempdata[index]['district']
      );
      let delivery_mode_unique = this.uniqueid(arr, (a) => a['Subscription_Type']);

      let totalTapalCount = 0;
      for (let j = 0; j < Object.keys(delivery_mode_unique).length; j++) {
        let arr1 = arr.filter(
          (a) => a['Subscription_Type'] == delivery_mode_unique[j]['Subscription_Type']
        );
        if (arr1[0]['Subscription_Type'] === type) {
          totalTapalCount = Object.keys(arr1).length;
        }
      }
      total_sub_count += totalTapalCount;
    }
    return total_sub_count;
  }
  uniqueid(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }

  deleteFromArray(obj: any) {
    this.jadaAnkTotal = 0
    this.jadaAnkData = this.jadaAnkData.filter(item => item.mode !== obj.mode);
    this.jadaAnkData.forEach((item, index) => {
      this.jadaAnkTotal = Number(this.jadaAnkTotal) + Number(item.prati);
    });
    this.lengthOfList = this.jadaAnkData.length;
    this.middleIndex = Math.floor(this.jadaAnkData.length / 2);
  }
  deleteFromSupremBhetArray(obj: any) {
    this.jadaAnkTotal = 0
    this.sapremBhet = this.sapremBhet.filter(item => item.mode !== obj.mode);
    this.sapremBhet.forEach((item, index) => {
      this.supremBhetTotal = Number(this.supremBhetTotal) + Number(item.prati);
    });
    this.lengthOfSapremBhet = this.sapremBhet.length;
    this.middleIndexSapremBhet = Math.floor(this.sapremBhet.length / 2);
  }
  karyalayTotal: any = 0
  krushiValue: any
  karylayInputValue: any
  karylayInputKey: any

  setKrushiValue() {

  }


}
